import { vappContainer, VApplication } from '../../../../../application';
import { logger as log } from '@common/logger';
import { ApplicationDetailPageService } from '../../../services';

const MODULE_NAME = 'profile.machines.states.getPage';

const getSrv = () => {
  return vappContainer.get<ApplicationDetailPageService>(
    ApplicationDetailPageService.displayName
  );
};
export const getCertificate = async (context: any, event: any) => {
  const currentState = 'GET_APPLICATION';
  const method = 'getCertificate';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const _getArgs = () => {
        let _args: any = {};
        if (event?.type === 'START') {
          _args = context['GET_APPLICATION'];
        }
        if (event?.type === 'TRIGGER_REFRESH') {
          _args = {
            offset: event?.offset ?? 0,
            size: event?.size ?? 10,
            where: event?.where ?? [],
          };
        }
        console.log('getCertificate args =>', _args);
        return _args;
      };
      const srv = getSrv();
      const content = await srv?.agent?.getCertificateDetail(_getArgs());
      console.log('getCertificatePageState?.event?.data?.value #1', content);
      if (content) {
        return resolve({
          key: 'RENDER_APPLICATION',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'RENDER_APPLICATION_ERROR',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'RENDER_APPLICATION_ERROR',
        value: _msg,
      });
    }
  });
};
